import { ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART } from '../types';

const initialState = {
  items: JSON.parse(localStorage.getItem('shopprs_cartItems')) ?? [],
};
export const cartReducers = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      return { ...state, items: action.payload };
    case REMOVE_FROM_CART:
      return { ...state, items: action.payload };
    case CLEAR_CART:
      return { ...state, items: [] };
    default:
      return state;
  }
};
